import tables from 'config/tables'
import { Config } from 'types'

const config: Config = {
  title: '',
  description: '',
  author: '',
  tables,
  orderbooks: {
    btc_usdt: {
      title: 'Orderbook 1',
      products: ['BTC', 'USDT'],
      current: 'BTC',
    },
    eth_usdt: {
      title: 'Orderbook 1',
      products: ['ETH', 'USDT'],
      current: 'ETH',
    },
  },
}

export default config
